//empty functions for web (no call or foreground service)
export function setupCallService() {
}

export const stopCallService = async () => {
}